// Browser detection Minified
!function(){var i=!!window.opr&&!!opr.addons||!!window.opera||navigator.userAgent.indexOf(" OPR/")>=0,e="undefined"!=typeof InstallTrigger,o=!!navigator.userAgent.match(/iPad/i)||!!navigator.userAgent.match(/iPhone/i)&&!!navigator.userAgent.match(/WebKit/i)&&!navigator.userAgent.match(/CriOS/i)||/constructor/i.test(window.HTMLElement)||"[object SafariRemoteNotification]"===(!window.safari||"undefined"!=typeof safari&&safari.pushNotification).toString(),n=!!document.documentMode,t=!n&&!!window.StyleMedia,a=!!window.chrome&&!!window.chrome.webstore,r=(a||i)&&!!window.CSS,s=[];i&&s.push("is-opera"),e&&s.push("is-firefox"),o&&s.push("is-safari"),n&&s.push("is-ie"),t&&s.push("is-edge"),a&&s.push("is-chrome"),r&&s.push("is-blink"),document.documentElement.className+=" "+s.join(" ")}();

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

let bodyForm = document.querySelector( "body" )
if( bodyForm.classList.contains( "site-2335" ) ){

    //bodyForm.querySelector( ".email-signup .gdpr-wrap" ).remove();
    let fields_wrap = bodyForm.querySelector( ".email-signup-velocity .fields-wrap" )

    let text = document.createElement( "div" );
    text.innerHTML = "**By submitting this request to join the email and/or SMS club, I certify that I have read the terms and conditions provided (https://www.highvelocityindy.com/privacy-policy) and I agree to receive marketing emails and autodialed marketing messages from High Velocity at the email address and phone number I have provided. I understand that no purchase is necessary. For email, you may choose to unsubscribe at any time by clicking on the unsubscribe link included in all emails. For SMS, message and data rates apply. You can opt out or terminate the mobile service anytime by texting STOP to (833)-988-4383. For help, Text HELP to (833)-988-4383. Message frequency may vary. When you click the Submit button below, we will send a text message to your phone. To confirm that you received the message and that you want to receive offers and information, reply YES to confirm your registration."
    text.style.color = "#FFF"
    text.style.fontSize = "10px"

    if(fields_wrap){
        fields_wrap.appendChild( text );
        text.classList.add( "input" )
    }

    let email_signup_velocity_sms = document.querySelector( "#email-signup-velocity [name*=sms]" )
    if( email_signup_velocity_sms ){
        email_signup_velocity_sms.addEventListener( "click", (e) => {
            if( e.target.checked ){
                document.querySelector( "#email-signup-velocity [name=SMSOptin]" ).value = "TRUE"
            }else{
                document.querySelector( "#email-signup-velocity [name=SMSOptin]" ).value = "FALSE"
            }
        } )
    }

}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    const swiperADAduplicatedProcess = (currentSwiper) => {
		currentSwiper.slides.forEach((slide) => {
			if (slide.classList.contains('swiper-slide-duplicate')) {
				slide.setAttribute('aria-hidden', true);
				slide.setAttribute('tabindex', '-1');

				// REMOVE IDs
				slide.querySelectorAll('[id]').forEach((elementWithID) => {
					elementWithID.setAttribute('id', '');
				});

				// SET TABINDEXs -1
				slide.querySelectorAll('a').forEach((elementWithID) => {
					elementWithID.setAttribute('tabindex', '-1');
				});
			}
		});

		currentSwiper.el.querySelectorAll('.swiper-slide .swiper-pagination-bullet').forEach((dotInSlide) => {
			dotInSlide.setAttribute('tabindex', '-1');
		});
	}; 

	// SWIPER
	const swiperClass = '.swiper';
	const swiperOps = {
		loop: true,
		fadeEffect: { crossFade: true },
		allowTouchMove: true,
		breakpoints: {
			767: {
				allowTouchMove: false,
			},
		},
		on: {
			init: function (currentSwiper) {
				swiperADAduplicatedProcess(currentSwiper);
			},
		},
	}; 

	document.querySelectorAll(swiperClass).forEach((slider, i) => {
		const dataOps = slider.dataset.swiper ? JSON.parse(slider.dataset.swiper) : {};
		const combinedOps = Object.assign({}, swiperOps, dataOps);

		slider.setAttribute(`data-swiper${i}`, '');
		const swiper = new Swiper(`[data-swiper${i}]`, combinedOps);

		swiper.on('slideChange', (currentSwiper) => {
			swiperADAduplicatedProcess(currentSwiper);
		});
	});

 
	document.querySelectorAll('[data-swiper-goto]').forEach((item) => {
		const target = item.dataset.swiperGoto ? parseInt(item.dataset.swiperGoto) : 0;
		const slider = item.dataset.swiperTarget ? document.querySelector(item.dataset.swiperTarget) : item.closest('.sym-slides');

		item.addEventListener('click', () => {
			slider.swiper.slideTo(target);
			item.parentNode.querySelectorAll('[data-swiper-goto]').forEach((itm) => itm.classList.remove('js-swiper_active'));
			item.classList.add('js-swiper_active');
		});
	});

	document.querySelectorAll('[data-swiper-prev]').forEach((item) => {
		const slider = item.dataset.swiperTarget ? document.querySelector(item.dataset.swiperTarget) : item.closest('.sym-slides');
		item.addEventListener('click', () => slider.swiper.slidePrev());
	});
	document.querySelectorAll('[data-swiper-next]').forEach((item) => {
		const slider = item.dataset.swiperTarget ? document.querySelector(item.dataset.swiperTarget) : item.closest('.sym-slides');
		item.addEventListener('click', () => slider.swiper.slideNext());
	});

})();

function scrollToElement(element){
    if(!element)
        return false;
    console.log('scroll...');
    
    element.scrollIntoView({ 
        behavior: "smooth", 
        block: "center"
    });
    /*
        * The properties used for the parameter 'block' it's for indicate where the section found should be respect the screen 'start, center, end'
    */
}

/*
   ? Open Scroll Animation If The Url Has '#'
*/
    window.addEventListener("load", (event) => {
        let sectionId = location.hash.substring(1);
        let sectionFromid = document.getElementById(sectionId);
        scrollToElement(sectionFromid);
    });
/*
   ? Close Scroll Animation If The Url Has '#'
*/

document.addEventListener('DOMContentLoaded', () => {
    let allAnchors = document.querySelectorAll('a');
    allAnchors.forEach( anchor => {
        if(anchor.href.includes('#')){
            anchor.addEventListener('click', (e) => {
                let sectionId = anchor.hash.substring(1);
                let sectionFromid = document.getElementById(sectionId);
                if( sectionFromid ){
                    e.preventDefault();
                    scrollToElement(sectionFromid);
                }
            })
        }
    })
});